module.exports = __webpack_public_path__ + "media/Images/icon-download-purple-o-8dcbaac45578a2395ef77e3bfce7a233.svg";